import { Box, TextField, Typography } from '@mui/material';
import React from 'react';
import i18n from '../../i18';
import { styled } from '@mui/system';

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-input': {
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '20px',
        textAlign: 'left'
    }
}));

export const RangeValue = ({
    fromValue,
    toValue,
    handleChangeFromValue,
    handleChangeToValue,
    fromLabel = 'from',
    toLabel = 'to',
    fromSymbol,
    toSymbol
}) => {
    return (
        <Box display="flex" flexDirection="column" gap={2} p={2}>
            <Box
                display="flex"
                alignItems="center"
                gap={1}
                justifyContent="space-between"
            >
                <Typography variant="subtitle2">
                    {i18n.t(`columns.${fromLabel}`)}
                </Typography>
                <Box display="flex" alignItems="center" width="130px" gap={1}>
                    <StyledTextField
                        variant="outlined"
                        size="small"
                        value={fromValue}
                        onChange={handleChangeFromValue}
                    />

                    {fromSymbol && (
                        <Typography variant="subtitle2">
                            {fromSymbol}
                        </Typography>
                    )}
                </Box>
            </Box>
            <Box
                display="flex"
                alignItems="center"
                gap={1}
                justifyContent="space-between"
            >
                <Typography variant="subtitle2">
                    {i18n.t(`columns.${toLabel}`)}
                </Typography>
                <Box display="flex" alignItems="center" width="130px" gap={1}>
                    <StyledTextField
                        variant="outlined"
                        size="small"
                        value={toValue}
                        onChange={handleChangeToValue}
                    />
                    {toSymbol && (
                        <Typography variant="subtitle2">{toSymbol}</Typography>
                    )}
                </Box>
            </Box>
        </Box>
    );
};
